var _path, _path2, _path3, _polygon, _polygon2, _polygon3, _polygon4, _path4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDhlApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Vector",
    width: "512px",
    height: "512px",
    x: "0px",
    y: "0px",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDCA2E",
    d: "M512,472c0,22.1-17.9,40-40,40l-432,0c-22.1,0-40-17.9-40-40V40C0,17.9,17.9,0,40,0h432 c22.1,0,40,17.9,40,40V472z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0131D",
    d: "M198.9,268.2c4.5-9.1,8.3-17,10-20.4c8.1-16.3-0.3-39.1-28.3-39.1h-92L72.7,241h85.8c6.7,0,9.1,1.4,7.1,5.6 c-2,4.1-6.2,12.7-7.4,15.1c-1.4,2.9-2.1,6.5,2.4,6.5C163.4,268.2,198.9,268.2,198.9,268.2L198.9,268.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0131D",
    d: "M141.6,271.3c-4.5,0-4.9-3-3.8-5.3c0.9-1.9,6.9-14.1,8.1-16.4c1.4-2.9,1-5.9-5.9-5.9h-38.9l-29.3,59.6 c0,0,56.1,0,77.2,0c21.1,0,36.4-7.6,46.9-28.9c0.5-1,1-2.1,1.5-3.1H141.6L141.6,271.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D0131D",
    points: "206.3,271.3 190.6,303.3 238.5,303.3 254.3,271.3 206.3,271.3 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D0131D",
    points: "273.7,271.3 258,303.3 305.9,303.3 321.7,271.3 273.7,271.3 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D0131D",
    points: "323.2,268.2 352.4,208.7 304.5,208.7 288.7,241 269.1,241 285,208.7 237,208.7 207.9,268.2  323.2,268.2 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D0131D",
    points: "364.6,208.7 412.6,208.7 383.3,268.2 335.4,268.2 364.6,208.7 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0131D",
    d: "M333.9,271.3l107.3,0l-15.7,32c0,0-72.8,0-79.1,0c-16.5,0-21.8-12.6-15.9-24.8 C331,277.1,333.9,271.3,333.9,271.3L333.9,271.3z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D0131D",
    points: "80,271.3 75.4,280.7 0,280.7 0,271.3 80,271.3 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D0131D",
    points: "74.5,282.5 69.8,292 0,292 0,282.5 74.5,282.5 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D0131D",
    points: "68.9,293.9 64.2,303.3 0,303.3 0,293.9 68.9,293.9 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D0131D",
    points: "512,280.7 443.2,280.7 447.8,271.3 512,271.3 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D0131D",
    points: "512,292 437.6,292 442.2,282.5 512,282.5 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D0131D",
    points: "512,303.3 432,303.3 436.7,293.9 512,293.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhlApi);
export default __webpack_public_path__ + "static/media/dhl-api.dcf3b2a1e78747f094947721e4cc959e.svg";
export { ForwardRef as ReactComponent };